<template>
  <div class="video-list">
    <p class="tips">
      <i class="el-icon-info"></i>
      <span>只有团队队长才能进行视频的管理操作</span>
    </p>
    <el-table :data="list" stripe class="list">
      <el-table-column prop="episode" label="集数" width="80" align="center">
      </el-table-column>
      <el-table-column prop="title" label="文案标题"> </el-table-column>
      <el-table-column label="操作" width="380" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="text"
            @click="
              form = {
                episode: row.episode,
                title: row.title,
                content: row.content,
              };
              show = true;
            "
            >查看文案</el-button
          >
          <el-button
            size="mini"
            type="text"
            @click="handleCheck(row.waId, row.title)"
            >查看脚本</el-button
          >
          <el-button
            v-if="row.originVideo"
            size="mini"
            type="text"
            @click="
              showVideo = true;
              videoUrl = row.originVideo;
            "
            >源视频</el-button
          >
          <el-button
            v-if="row.productionVideo"
            size="mini"
            type="text"
            @click="
              showVideo = true;
              videoUrl = row.productionVideo;
            "
            >后期视频</el-button
          >
          <uploadFile
            v-if="isCaptain && !row.productionVideo"
            style="display: inline-block; margin: 0 8px"
            :fileType="fileType"
            @success="uploadSuccess"
            @click.native.stop="waId = row.waId"
          >
            <el-button size="mini" type="text">上传后期视频</el-button>
          </uploadFile>

          <el-button
            v-if="isCaptain && row.productionVideo"
            size="mini"
            type="text"
            @click="handleDel(row.waId)"
            >删除后期视频</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog class="detail-dialog" :visible.sync="show" width="40%" center>
      <table
        width="100%"
        border="1"
        cellspacing="0"
        cellpadding="10"
        align="center"
        class="table"
      >
        <tr>
          <td class="label" width="20%">集数</td>
          <td>第{{ form.episode }}集</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案名称</td>
          <td>{{ form.title }}</td>
        </tr>
        <tr>
          <td class="label" width="20%">文案内容</td>
          <td><div v-html="form.content"></div></td>
        </tr>
      </table>
    </el-dialog>

    <el-dialog title="脚本列表" :visible.sync="showScenario" width="80%" center>
      <p style="margin-bottom: 10px">
        所属文案名称: <b>{{ waName }}</b>
      </p>
      <el-table :data="sList" stripe class="list">
        <el-table-column type="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column prop="jb" label="景别" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jd" label="角度" width="80" align="center">
        </el-table-column>
        <el-table-column prop="jtsc" label="镜头时长" width="80" align="center">
        </el-table-column>
        <el-table-column
          prop="pshm"
          label="拍摄画面"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="sy"
          label="声音"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="py" label="配乐" width="100" align="center">
        </el-table-column>
        <el-table-column
          prop="psdd"
          label="拍摄地点"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="dj" label="道具" width="100" align="center">
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      class="video-dialog"
      :visible.sync="showVideo"
      width="40%"
      :close-on-click-modal="false"
    >
      <video
        v-if="showVideo"
        style="width: 100%; max-height: 55vh"
        :src="videoUrl"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import {
  videoList,
  saveVideo,
  delVideo,
} from "@/api/projectPractice/videoClip";
import { scenarioList } from "@/api/projectPractice/scenario";
import uploadFile from "@/components/uploadFile";

export default {
  components: {
    uploadFile,
  },
  data() {
    return {
      isCaptain: false,
      list: [],
      form: {},
      show: false,
      showVideo: false,
      videoUrl: "",
      fileType: [],
      waId: null,
      sList: [],
      waName: "",
      showScenario: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 视频列表
    getList() {
      this.$loading.show();
      videoList({ classId: this.$route.query.id }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data.list;
          this.isCaptain = res.data.isCaptain;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    uploadSuccess(file) {
      saveVideo({ waId: this.waId, videoUrl: file.url }).then((res) => {
        if (res.code == 0) {
          this.getList();
          this.$message.success("上传成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除视频
    handleDel(waId) {
      this.$confirm("确定要删除视频吗?", {
        type: "warning",
      })
        .then(() => {
          delVideo(waId).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 脚本详情
    handleCheck(waId, waName) {
      this.waName = waName;
      this.$loading.show();
      scenarioList(waId).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.sList = res.data;
          this.showScenario = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.video-list {
  .tips {
    margin-bottom: 10px;
    text-align: left;
    color: #f56c6c;
    i {
      margin-right: 5px;
    }
  }
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
  .detail-dialog {
    .label {
      text-align: center;
      font-weight: bold;
      background: #f5f5f5;
    }
  }
}
</style>